import { arrow } from "@/designSystemIcons";
import { clsx } from "clsx";
import React from "react";

interface FiltersToggleButtonProps {
  showAll: boolean;
  onToggle: () => void;
}

const ToggleAllButton: React.FC<FiltersToggleButtonProps> = ({
  showAll,
  onToggle,
}) => {
  return (
    <button
      className="rounded-full h-9 px-2 bg-[#49535F] hover:bg-[#5F6C7C] text-dark-secondary hover:text-dark-primary flex items-center justify-center whitespace-nowrap"
      onClick={onToggle}
    >
      <div className="flex gap-2 items-center">
        <div>{showAll ? "Show less" : "Show all"}</div>
        <div className={clsx("h-3 w-3", showAll && "rotate-180")}>{arrow}</div>
      </div>
    </button>
  );
};

export default ToggleAllButton;
